import type { CrudSelection } from '../typings'

import { crudAtom } from '../crud'

export const resetCrudSelection = (category: keyof CrudSelection) => {
  crudAtom.selection[category] = []
  return crudAtom.selection[category]
}
